var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBoat = function SvgBoat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.773 12.03 4.532-.446a1 1 0 0 1 1.015 1.394l-.806 1.85a1 1 0 0 1-.874.599l-7.14.306m3.273-3.703L2.335 13.452a1 1 0 0 0-.828 1.373l1.858 4.553a1 1 0 0 0 .926.622h13.931a1 1 0 0 0 .874-.513l.904-1.62m-3.227-5.837-1.63-2.53M3.75 10V8a1 1 0 0 1 1-1h5.679m0 0h2.59a1 1 0 0 1 .847.468L15.143 9.5M10.429 7l-.814-2.33A1 1 0 0 0 8.671 4H7.238a1 1 0 0 0-1 1v.5m8.905 4L10 10",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgBoat as ReactComponent };
export default __webpack_public_path__ + "static/media/boat.35fee2b9.svg";